module.exports = "/images/oculus-4.jpg";